module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-regular.7b5cdc0c.ttf";